import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { DATE_DISPLAY_FORMAT } from "../../utils/dateUtils";

/**
 * Reusable FormDatePicker component with validation display.
 * Reusable FormDatePicker component with validation display
 * 
 * @param {string} name - Field name (for formik)
 * @param {string} label - Field label
 * @param {object} formik - Formik object (optional, for validation)
 * @param {boolean} required - Required field indicator
 * @param {object} sx - Custom styles
 * @param {object} ...otherProps - Other DatePicker props
 */
const FormDatePicker = ({
  name,
  label,
  formik,
  value: externalValue,
  onChange: externalOnChange,
  required = false,
  sx = {},
  error: externalError,
  touched: externalTouched,
  ...otherProps
}) => {
  const formikHasName = formik && name;

  const formikValue = formikHasName ? formik.values?.[name] : undefined;
  const currentValue = formikValue !== undefined ? formikValue : externalValue ?? null;

  const touchedState = formikHasName ? formik.touched?.[name] : externalTouched;
  const errorState = formikHasName ? formik.errors?.[name] : externalError;

  const normalize = (v) => {
    if (v === null || v === undefined || v === "") return null;
    if (v instanceof Date) return v;
    // If it's an ISO/string parseable date -> convert to Date
    const parsed = Date.parse(v);
    return isNaN(parsed) ? v : new Date(parsed);
  };

  const handleChange = (newValue) => {
    if (formikHasName) {
      formik.setFieldValue(name, newValue);
      formik.setFieldTouched(name, true);
    }
    if (externalOnChange) externalOnChange(newValue);
  };

  const { slotProps: userSlotProps, ...restPickerProps } = otherProps || {};

  return (
    <DatePicker
      label={label}
      format={DATE_DISPLAY_FORMAT}
      value={normalize(currentValue)}
      onChange={handleChange}
      slotProps={{
        ...userSlotProps,
        textField: {
          fullWidth: true,
          required,
          error: !!(touchedState && errorState),
          helperText: touchedState && errorState ? errorState : undefined,
          sx,
          ...userSlotProps?.textField,
          inputProps: {
            inputMode: "numeric",
            autoComplete: "off",
            ...(userSlotProps?.textField?.inputProps || {}),
          },
        },
      }}
      {...restPickerProps}
    />
  );
};

export default FormDatePicker;

